module.exports = __webpack_public_path__ + "img/i-burger-white.6a143eb3.svg";